document.addEventListener("DOMContentLoaded", function () {
	// gsap.registerPlugin(ScrollToPlugin);
});

function scrollToNextRow(button) {
	const headerHeight = document.querySelector("header").offsetHeight;
	const currentRow = button.closest(".flex-layout");
	let scrollTarget;
	const nextLayout = currentRow.nextElementSibling;
	const nextRow = currentRow.parentElement.nextElementSibling;

	nextLayout !== null && nextRow !== null ? scrollTarget = nextLayout : scrollTarget = nextRow;
	
	gsap.to(window, {
		duration: 0.5,
		scrollTo: {
			y: scrollTarget,
			autoKill: false,
			offsetY: headerHeight,
		},
	});
}
